import { takeWhile } from 'lodash/fp'
import { useCallback, useState } from 'react'
import { useKey } from 'react-use'

import { ActionHandler, ActionKey } from '../../Types'
import { useNeutralStateMenuVisible } from './useNeutralStateMenuVisible'

interface UseItemContextMenuProps {
  handlers: ActionHandler[]
}

export const useItemContextMenu = ({ handlers }: UseItemContextMenuProps) => {
  const [visible, _setVisible] = useState(false)
  const neutralState = useNeutralStateMenuVisible()

  const setVisible = useCallback(
    (next: boolean) => {
      // hide neutral state menu if it is open and we are opening an item menu
      neutralState.setVisible(false)
      _setVisible(next)
    },
    [neutralState],
  )

  const handleAction = (key: ActionKey) => {
    if (key === ActionKey.move) {
      // No op: The menu remains visible
    } else {
      setVisible(false)
    }
    takeWhile((handler) => !handler(key), handlers)
  }

  useKey('Escape', () => setVisible(false), { options: true })

  return { visible, setVisible, handleAction }
}
